module.exports = __webpack_public_path__ + "img/KRAYARSK.e1547fb7.png";